import React from 'react'

const MyFirstContainer = function () {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontSize: 100 }}>
      hello world
    </div>
  )
}

export default MyFirstContainer
